import "core-js/modules/web.dom.iterable";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import timeCount from "@/components/timeCount/timeCount.vue";
import { getLang } from '@/api/utils/apiHelper';

var Reval =
/*#__PURE__*/
function (_Vue) {
  _inherits(Reval, _Vue);

  function Reval() {
    var _this;

    _classCallCheck(this, Reval);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Reval).apply(this, arguments));
    _this.timeStr = "";
    _this.countTime = 24 * 3600;
    _this.timer = null;
    return _this;
  }

  _createClass(Reval, [{
    key: "renderScrollItem",
    value: function renderScrollItem(item) {
      var htmlStr = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(item.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (typeof i === "number") {
            htmlStr += "<p class='high'>".concat(i, "</p>");
          } else {
            htmlStr += "<span class='normal'>".concat(i, "</span>");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return htmlStr;
    }
  }, {
    key: "getTimeStr",
    value: function getTimeStr(val) {
      var hour = Math.floor(val / 3600);
      var min = Math.floor(val % 3600 / 60);
      var sec = Math.floor(val % 60);
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      return hour + ":" + min + ":" + sec;
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this2 = this;

      clearInterval(this.timer);
      this.countTime - 1;
      this.timeStr = this.getTimeStr(this.countTime);
      this.timer = setInterval(function () {
        _this2.countTime -= 1;

        if (_this2.countTime > 0) {
          _this2.timeStr = _this2.getTimeStr(_this2.countTime);
        } else {
          clearInterval(_this2.timer);
        }
      }, 1000);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var nowTime = new Date().valueOf();
      var todayStr = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate();
      var todayZeroTime = new Date(todayStr).getTime(); // 当天0点时间戳

      this.countTime = Math.floor((todayZeroTime + 24 * 3600000 - nowTime) / 1000);
      this.initData();
    }
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "isSpanish",
    get: function get() {
      return getLang() === "es";
    }
  }, {
    key: "scrollList",
    get: function get() {
      var list = [["<span class='today-only'>" + this.$t("common.button.today_only") + "</span>"], ["<span class=\"time-str\">".concat(this.timeStr, "</span>"), "<span>" + this.$t("common.button.left") + "</span>"]];
      return list;
    }
  }]);

  return Reval;
}(Vue);

tslib_1.__decorate([Prop({
  default: "page"
})], Reval.prototype, "type", void 0);

Reval = tslib_1.__decorate([Component({
  components: {
    timeCount: timeCount
  }
})], Reval);
export default Reval;